<template>
  <a-card class="problem-report-form-card">
    <ValidationObserver ref="observer">
      <a-form
        :label-width="80"
        slot-scope="{ validate }"
        @submit.prevent="validate().then(handleSubmit)"
      >
        <h2 class="title">{{ labels.title }}</h2>
        <p class="details">{{ labels.details }}</p>
        <a-row
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :span="24">
            <Input
              v-model="form.name"
              rules="required"
              vid="name"
              :placeholder="labels.form.name.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.name.label"
              icon="user"
              @input="onlyAlfa($event, 'name')"
            />
          </a-col>
        </a-row>
        <a-row
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :lg="24" :md="12" :sm="24" :xs="24">
            <Input
              v-model="form.email"
              rules="required|email"
              vid="email"
              :placeholder="labels.form.email.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.email.label"
              icon="mail"
            />
          </a-col>
          <a-col :lg="24" :md="12" :sm="24" :xs="24">
            <Input
              v-model="form.phone"
              rules="phoneNumber"
              vid="phone"
              :placeholder="labels.form.phone.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.phone.label"
              icon="phone"
              v-themask="['(###) ###-####']"
            />
          </a-col>
        </a-row>
        <a-row
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :span="24">
            <TextArea
              v-model="form.message"
              rules="required"
              vid="message"
              :placeholder="labels.form.message.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.message.label"
              :autoSize="{ minRows: 4, maxRows: 6 }"
            />
          </a-col>
        </a-row>
        <a-row
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :span="24">
            <!-- Subscribe button -->
            <a-form-item>
              <a-button
                type="default"
                html-type="submit"
                :loading="submitting"
                :disabled="submitting"
                size="large"
                class="btn-send"
                @click.prevent="validate().then(handleSubmit)"
              >
                <span>{{ labels.form.submit }}</span>
              </a-button>
              <a-upload
                :file-list="fileList"
                name="attachments"
                :multiple="true"
                class="upload-attachment"
                accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                @change="handleFileChange"
              >
                <a-button :loading="submitting" class="btn-attachment">
                  <a-icon type="upload" />
                  {{ labels.form.attachments.placeholder }}
                </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </ValidationObserver>
  </a-card>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import _ from "lodash";
import { VueMaskFilter } from "v-mask";
import { mask } from "vue-the-mask";
import Input from "@/components/core/VeeValidateForm/Input";
import TextArea from "@/components/core/VeeValidateForm/TextArea";
import labels from "@/utils/labels";
import { mapActions } from "vuex";
const initialState = {
  name: "",
  email: "",
  phone: "",
  message: "",
  attachments: [],
};
export default {
  name: "problemReportForm",
  directives: { themask: mask },
  components: {
    ValidationObserver,
    Input,
    TextArea,
  },
  data() {
    return {
      form: _.cloneDeep(initialState),
      submitting: false,
      fileList: [],
      labels: {
        ...labels.problemReportForm,
        appName: labels.appName,
        unknownServerError: labels.unknownServerError,
      },
    };
  },
  methods: {
    ...mapActions(["sendProblemReportEmail"]),
    async handleSubmit() {
      try {
        this.submitting = true;
        const formData = new FormData();
        for (let key in this.form) {
          if (key !== "attachments") formData.append(key, this.form[key]);
        }
        for (let i = 0; i < this.fileList.length; i++) {
          const file = this.fileList[i];
          formData.append("attachments[]", file.originFileObj);
        }
        await this.sendProblemReportEmail(formData);
        this.$success({
          title: this.labels.form.success,
          centered: true,
          // JSX support
          content: (
            <div>
              <p>
                {this.form.name}, <br />
                {this.labels.form.successEmail}
              </p>
            </div>
          ),
          onOk: () => {
            this.form = _.cloneDeep(initialState);
            this.$refs.observer?.reset();
          },
        });
      } catch (error) {
        this.$notification["error"]({
          message: `${this.labels.error}`,
          description: this.labels.errorMessage,
        });
      } finally {
        this.submitting = false;
      }
    },
    async onlyAlfa(value = "", field) {
      this.form[field] = await value.replace(/[^a-zA-Z\s]/g, "");
    },
    handleFileChange(files) {
      let fileList = [...files.fileList];
      // Max 5 files
      if (fileList.length > 5) {
        fileList = fileList.slice(-5);
        this.fileList = fileList;
        this.showMaxFilesNotification();
      }
      this.fileList = fileList;
    },
    // Avoid multiple notifications
    showMaxFilesNotification() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$notification["warning"]({
          message: this.labels.form.attachments.warning,
          description: this.labels.form.attachments.maxFiles,
        });
      }, 200);
    },
  },
  fiters: {
    mask: VueMaskFilter,
  },
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.problem-report-form-card {
  background-color: var(--card-shop-bg);
  border-color: var(--card-shop-shadow);
  padding: 3.125rem;
  border-radius: 8px;
  @media screen and (max-width: $screen-mobile) {
    padding: 2.125rem 1rem;
  }
  .title {
    font-family: "Exo 2", sans-serif;
    color: var(--text);
    font-weight: 400;
    margin: 0;
    line-height: 1.3;
    word-break: break-word;
    font-size: 2rem;
    margin-bottom: 1rem;
  }
  .details {
    font-family: "Exo 2", sans-serif;
    color: var(--text);
    margin: 0;
    word-break: break-word;
    margin-bottom: 1rem;
  }
  .ant-card-body {
    padding: 0;
  }
  .ant-form label {
    font-size: 0.875rem;
    color: var(--text);
    font-family: "Roboto", sans-serif;
  }
  .ant-input {
    background-color: var(--card-bg);
    height: 3.75rem;
    color: var(--text);
    &:active,
    &:focus,
    &:hover {
      border-color: var(--text-active);
    }
  }
  .ant-input-affix-wrapper {
    .ant-input:not(:first-child) {
      padding-left: 2.8125rem;
    }
    .ant-input-prefix {
      color: var(--text);
      font-size: 1.375rem;
      font-family: "Roboto", sans-serif;
    }
    .ant-input-clear-icon,
    .ant-input-textarea-clear-icon {
      color: var(--text);
    }
  }

  .has-error .ant-input-affix-wrapper .ant-input,
  .has-error .ant-input-affix-wrapper .ant-input:hover {
    background-color: var(--card-bg);
  }

  .upload-attachment {
    .ant-upload {
      @media screen and (max-width: 596px) {
        width: 100% !important;
        margin-top: 10px;
      }

      .btn-attachment {
        color: var(--btn-text-secondary);
        border-color: var(--btn-bc-secondary);
        background-color: var(--btn-bg-secondary);
        transition: all 0.5s ease;
        @media screen and (max-width: 596px) {
          width: 100% !important;
          margin-top: 10px;
        }

        &:hover {
          color: var(--btn-text-secondary);
          border-color: var(--btn-bc-secondary);
          background-color: var(--btn-bg-secondary);
          transition: all 0.5s ease;
        }
      }
    }

    .ant-upload-list {
      margin-top: 20px;
    }
  }

  .btn-send {
    color: var(--btn-text-primary);
    background-color: var(--btn-bg-primary);
    border-color: var(--btn-bc-primary);
    height: 51px;
    padding: 0 1.75rem;
    float: right;
    @media screen and (max-width: 596px) {
      width: 100% !important;
      margin-top: 10px;
    }
  }
}

input:-internal-autofill-selected {
  background-color: var(--input-bg) !important;
  border-color: var(--text-active) !important;
  color: var(--text-muted) !important;
}
</style>
